<template>
    <div class="bitacora">
        <!-- Diálogo modal Persistente para seleccionar la Caseta -->
        <v-dialog v-model="dialog_inicio" persistent max-width="400px">
            <v-form @submit.prevent="set_caseta()">
                <v-card class="justify-center">
                    <v-toolbar dark color="primary">
                        <v-toolbar-title>
                            {{$t('selecciona_caseta')}}
                        </v-toolbar-title>
                    </v-toolbar>
                    <v-card-text>
                        <v-autocomplete
                                v-model="caseta"
                                name="caseta"
                                :items="casetas"
                                item-text="nombre"
                                item-value="id"
                                :label="$t('Casetas')"
                        ></v-autocomplete>
                    </v-card-text>
                    <v-card-actions class="justify-center">
                        <v-btn
                                color="primary"
                                type="submit"
                        >{{ $t('aceptar') }}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-dialog>
        <!--    Diálogo Persistente para mostrar Errores   -->
        <v-dialog v-model="dialog_errores"
                  persistent
                  width="400"
        >
            <v-card class="justify-center">
                <v-card-title
                        :class="head_color"
                        primary-title
                >
                    {{$t('aviso')}}
                </v-card-title>
                <v-card-text>
<!--                    <h3 class="text-xs-center">{{errores_guard}}</h3>-->
                    <div class="text-xs-center" v-html="errores_guard" />
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions class="justify-center">
                    <v-btn
                            v-if="band_gafete"
                            color="primary"
                            x-small
                            :loading="loading_gafete"
                            @click="download_gafete(dataAccessNoCode.nombre, dataAccessNoCode.host, dataAccessNoCode.f_acceso, dataAccessNoCode.company_logo)"
                    >{{$t('print_name_tag')}}
                    </v-btn>
                    <v-btn
                            color="primary"
                            @click="dialog_errores = false, errores_guard = '', band_gafete = false"
                    >
                        {{$t('aceptar')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--    Diálogo Persistente para mostrar Mensaje   -->
        <v-dialog v-model="bandConfirm"
                  persistent
                  width="400"
        >
            <v-card class="justify-center">
                <v-card-title class="warning display-1 text--primary justify-center"
                      primary-title>
                    {{$t('aviso')}}
                </v-card-title>
                <v-card-text>
                    <div class="text-xs-center">
                      {{$t('at_least_one_data')}}
                    </div>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions class="justify-center">
                    <v-btn
                            color="primary"
                            @click="bandConfirm = false"
                    >
                        {{$t('aceptar')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialogTransport" persistent max-width="400px">
              <v-card class="justify-center">
                  <v-toolbar dark color="primary">
                      <v-toolbar-title>
                          {{bandTransportUpdate === true? $t('add_carrier_data') : $t('carrier_data')}}
                      </v-toolbar-title>
                  </v-toolbar>
                  <v-card-text class="text-xs-center">
                      <v-radio-group
                          row
                          :disabled="!bandTransportUpdate"
                          v-model="typeService"
                          prepend-icon="trolley"
                          name="typeService"
                          :mandatory="false"
                          :error-messages="errores.typeService"
                      >
                        <v-radio :label="$t('load')" :value="true"></v-radio>
                        <v-radio :label="$t('download')" :value="false"></v-radio>
                      </v-radio-group>
                      <v-text-field
                          v-model="case_plates"
                          :disabled="!bandTransportUpdate"
                          prepend-icon="inventory"
                          name="case_plates"
                          :label="$t('case_plates')"
                          :error-messages="errores.case_plates"
                      >
                      </v-text-field>
                      <v-text-field
                          v-model="container_platform_plates"
                          :disabled="!bandTransportUpdate"
                          prepend-icon="local_shipping"
                          name="container_platform_plates"
                          :label="$t('container_platform_plates')"
                          :error-messages="errores.container_platform_plates"
                      >
                      </v-text-field>
                      <v-text-field
                          v-model="transport_line"
                          :disabled="!bandTransportUpdate"
                          prepend-icon="rv_hookup"
                          name="transport_line"
                          :label="$t('transport_line')"
                          :error-messages="errores.transport_line"
                      >
                      </v-text-field>
                      <v-text-field
                          v-model="supplier_customer_name"
                          :disabled="!bandTransportUpdate"
                          prepend-icon="business"
                          name="supplier_customer_name"
                          :label="$t('supplier_customer_name')"
                          :error-messages="errores.supplier_customer_name"
                      >
                      </v-text-field>
                  </v-card-text>
                  <v-card-actions class="justify-center">
                      <v-btn
                              color="primary"
                              @click="dialogTransport = false"
                      >{{ $t('cancelar') }}
                      </v-btn>
                    <v-spacer/>
                    <v-btn
                        v-show="bandTransportUpdate === true"
                        color="primary"
                        @click="addAccessCarrierData"
                        :loading="loading"
                    >{{$t('guardar')}}
                    </v-btn>
                    <v-btn
                        v-show="bandTransportUpdate === false"
                        color="primary"
                        @click="dialogTransport = false"
                    >{{$t('aceptar')}}
                    </v-btn>
                  </v-card-actions>
              </v-card>
        </v-dialog>
        <v-dialog v-model="dialogPlacas" persistent max-width="400px">
              <v-card class="justify-center">
                  <v-toolbar dark color="primary">
                      <v-toolbar-title>
                          {{$t('placas')}}
                      </v-toolbar-title>
                  </v-toolbar>
                  <v-card-text class="text-xs-center">
                    <h3>{{$t('select_video_device')}}</h3>
                    <select v-model="camera">
                      <option>{{$t('select_video_device')}}</option>
                      <option
                          v-for="device in devices"
                          :key="device.deviceId"
                          :value="device.deviceId">
                        {{ device.label }}
                      </option>
                    </select>
                    <v-img
                        width="100%"
                        :src="img !== '' ? img : require('../../assets/sin-foto.png')"
                    >
                      <v-layout row wrap>
                        <v-flex class="text-xs-left">
                          <v-avatar
                              class="profile"
                              color="grey"
                              size="164"
                              tile
                          >
                            <div v-show="band" @click="onCapture()">
                              <vue-web-cam
                                  ref="webcam"
                                  :device-id="deviceId"
                                  width="100%"
                                  @started="onStarted"
                                  @stopped="onStopped"
                                  @error="onError"
                                  @cameras="onCameras"
                                  @camera-change="onCameraChange"
                              />
                            </div>
                          </v-avatar>
                        </v-flex>
                      </v-layout>
                    </v-img>
                    <v-spacer/>
                    <v-btn
                      color="primary"
                      @click="onCapture"
                    >
                      {{ $t('take_photo')}}
                    </v-btn>
                  </v-card-text>
                  <v-card-actions class="justify-center">
                      <v-btn
                              color="primary"
                              @click="dialogPlacas = false"
                      >{{ $t('cancelar') }}
                      </v-btn>
                    <v-spacer/>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <div v-on="on">
                          <v-btn
                              :disabled="img === ''"
                              color="primary"
                              @click="altaPlacas"
                              :loading="loading"
                          >{{$t('guardar')}}
                          </v-btn>
                        </div>
                      </template>
                      <span>{{img === '' ? $t('msg_must_capture_photo') : $t('guardar')}}</span>
                    </v-tooltip>
                  </v-card-actions>
              </v-card>
        </v-dialog>
        <v-dialog v-model="dialogShowPlacas" persistent max-width="400px">
              <v-card class="justify-center">
                  <v-toolbar dark color="primary">
                      <v-toolbar-title>
                          {{$t('placas')}}
                      </v-toolbar-title>
                  </v-toolbar>
                  <v-card-text class="text-xs-center">
                    <v-img
                        :src="imagenPlacas"
                        position="center center"
                        class="grey lighten-2"
                    ></v-img>
                  </v-card-text>
                  <v-card-actions class="justify-center">
                      <v-btn
                              color="primary"
                              @click="dialogShowPlacas = false, imagenPlacas = ''"
                      >{{ $t('cerrar') }}
                      </v-btn>
                  </v-card-actions>
              </v-card>
        </v-dialog>
        <v-container class="my-1">
            <v-layout calign-center>
                <v-dialog scrollable v-model="dialog_accesos_no_code_express" max-width="600">
                    <v-card color="blue-grey lighten-4"  class="elevation-5">
                        <v-toolbar dark color="primary">
                            <v-toolbar-title>Detalles</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-btn
                                    class="align-self-end"
                                    color="red"
                                    icon
                                    @click="dialog_accesos_no_code_express = false">
                                <v-icon>close</v-icon>
                            </v-btn>
                        </v-toolbar>
                        <v-card-text>
                            <div class="text-xs-center">
                                <v-layout justify-center class="text-xs-center" row wrap>
                                    <v-flex xs12>
                                        <v-layout align-center justify-center row wrap>
                                            <v-flex class="text-xs-center">
                                                <v-img
                                                        :src="data_accesos_no_code_express.url_foto"
                                                        position="center center"
                                                        class="grey lighten-2"
                                                ></v-img>
                                                <table id="datas">
                                                    <tr>
                                                        <th>
                                                            <h2>
                                                                {{$t('Visitante')}}:
                                                            </h2>
                                                        </th>
                                                        <td>
                                                            <h2>
                                                                {{ data_accesos_no_code_express.nombre}}
                                                            </h2>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th>
                                                            <h2>
                                                                {{$t('Area')}}:
                                                            </h2>
                                                        </th>
                                                        <td>
                                                            <h2>
                                                                {{ data_accesos_no_code_express.areaName}}
                                                            </h2>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th>
                                                            <h2>
                                                                {{$t('Notas')}}
                                                            </h2>
                                                        </th>
                                                        <td>
                                                            <h2>
                                                                {{ (data_accesos_no_code_express.notas === '' || data_accesos_no_code_express.notas === null) ? "Sin Notas" : data_accesos_no_code_express.notas}}
                                                            </h2>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th>
                                                            <h2>
                                                                {{$t('hora_acceso')}}
                                                            </h2>
                                                        </th>
                                                        <td>
                                                            <h2>
                                                                {{ data_accesos_no_code_express.f_acceso}}
                                                            </h2>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th>
                                                            <h2>
                                                                {{$t('hora_salida')}}
                                                            </h2>
                                                        </th>
                                                        <td>
                                                            <h2>
                                                                {{ data_accesos_no_code_express.f_salida ? data_accesos_no_code_express.f_salida : "Salida no registrada" }}
                                                            </h2>
                                                        </td>
                                                    </tr>
                                                </table>
                                            </v-flex>
                                        </v-layout>
                                    </v-flex>
                                </v-layout>
                            </div>
                        </v-card-text>
                    </v-card>
                </v-dialog>
                <v-dialog scrollable persistent v-model="dialog_accesos_without_code" max-width="1000">
                    <v-card :loading="loadingCountInAccessNoCode" v-if="entrada" :color="dataAccessNoCode.authorized ? 'blue-grey lighten-4' : 'yellow lighten-2'" class="elevation-5">
                        <v-toolbar dark color="primary">
                            <v-toolbar-title>{{$t('info_invitation')}}</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-btn
                                    class="align-self-end"
                                    color="red"
                                    icon
                                    @click="dialog_accesos_without_code = false">
                                <v-icon>close</v-icon>
                            </v-btn>
                        </v-toolbar>
                        <v-card-text>
                            <div class="text-xs-center">
                                <v-layout justify-center class="text-xs-center" row wrap>
                                    <v-flex xs12>
                                        <h2>{{$t('info_invitado')}}</h2>
                                        <br>
                                        <v-layout align-center justify-center row wrap>
                                            <v-flex class="text-xs-center" xs12 sm6>
                                              <v-img
                                                  :src="data_accesos_without_code.url_foto"
                                                  position="center center"
                                                  class="grey lighten-2"
                                              ></v-img>
                                            </v-flex>
                                            <v-flex class="text-xs-center" xs12 sm6>
                                                <table id="datas">
                                                    <tr>
                                                        <th>
                                                            <h2>
                                                                {{$t('Visitante')}}:
                                                            </h2>
                                                        </th>
                                                        <td>
                                                            <h2>
                                                                {{ data_accesos_without_code.nombre}}
                                                            </h2>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th>
                                                            <h2>
                                                                {{$t('Empresa')}}:
                                                            </h2>
                                                        </th>
                                                        <td>
                                                            <h2>
                                                                {{ data_accesos_without_code.empresa}}
                                                            </h2>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th>
                                                            <h2>
                                                                {{$t('Area')}}:
                                                            </h2>
                                                        </th>
                                                        <td>
                                                            <h2>
                                                                {{ data_accesos_without_code.areaName}}
                                                            </h2>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th>
                                                            <h2>
                                                                {{$t('Notas')}}
                                                            </h2>
                                                        </th>
                                                        <td>
                                                            <h2>
                                                                {{ data_accesos_without_code.notas}}
                                                            </h2>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th>
                                                            <h2>
                                                                {{$t('hora_acceso')}}
                                                            </h2>
                                                        </th>
                                                        <td>
                                                            <h2>
                                                                {{ data_accesos_without_code.f_acceso}}
                                                            </h2>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th>
                                                            <h2>
                                                                {{$t('hora_salida')}}
                                                            </h2>
                                                        </th>
                                                        <td>
                                                            <h2>
                                                                {{ data_accesos_without_code.f_salida ? data_accesos_without_code.f_salida : "Salida no registrada" }}
                                                            </h2>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th>
                                                            <h2>
                                                                {{$t('Anfitrion')}}
                                                            </h2>
                                                        </th>
                                                        <td>
                                                            <h2>
                                                                {{data_accesos_without_code.host}}
                                                            </h2>
                                                        </td>
                                                    </tr>
                                                </table>
                                            </v-flex>
                                        </v-layout>
                                    </v-flex>
                                </v-layout>
                            </div>
                          </v-card-text>
                        <v-card-actions class="justify-center">
                          <v-layout align-center justify-center row wrap>
                            <v-flex v-if="!dataAccessNoCode.authorized" xs12 class="text-xs-center">
                              <h3>{{$t('attemps')}} : {{dataAccessNoCode.count_authorized}}/2</h3>
                            </v-flex>
                            <v-flex xs12 class="text-xs-center">
                              <v-btn
                                  large
                                  color="error"
                                  @click="dialog_accesos_without_code = false"
                              >{{ $t('cerrar')}}
                              </v-btn>
                              <v-btn
                                  v-if="dataAccessNoCode.authorized"
                                  large
                                  color="success"
                                  :loading="loading"
                                  @click="create_access_no_code(dataAccessNoCode.id), dialog_accesos_without_code = false, entrada = false, salida = false"
                              >{{$t('acceso')}}
                              </v-btn>
                              <v-btn
                                  v-if="!dataAccessNoCode.authorized && dataAccessNoCode.count_authorized !== 0 && countDownAuthorizedAccessNoCode === 0"
                                  large
                                  color="primary"
                                  :loading="loading"
                                  @click="notificar_anfitrion_acceso_sin_codigo(dataAccessNoCode.id)"
                              >
                                Notificar al anfitrión <br> autorizar acceso
                              </v-btn>
                              <v-btn
                                  v-if="!dataAccessNoCode.authorized && dataAccessNoCode.count_authorized !== 0 && countDownAuthorizedAccessNoCode > 0"
                                  large
                                  color="primary"
                              >
                                Disponible en : {{countDownAuthorizedAccessNoCode}}
                              </v-btn>
                              <v-btn
                                  v-if="!dataAccessNoCode.authorized && dataAccessNoCode.count_authorized === 0"
                                  large
                                  color="success"
                                  :loading="loading"
                                  @click="create_access_no_code(dataAccessNoCode.id), dialog_accesos_without_code = false, entrada = false, salida = false"
                              >{{$t('acceso')}}
                              </v-btn>
                              <v-btn
                                  v-if="!dataAccessNoCode.authorized && dataAccessNoCode.count_authorized !== 0"
                                  large
                                  :loading="loadingCountInAccessNoCode"
                                  color="primary"
                                  @click="getRecordAccessNoCodeById(dataAccessNoCode.id)"
                              >
                                <v-icon>refresh</v-icon>
                              </v-btn>
                            </v-flex>
                          </v-layout>
                        </v-card-actions>
                    </v-card>
                    <v-card :loading="loadingCountInAccessNoCode" v-if="salida" :color="dataAccessNoCode.pase_salida ? 'blue-grey lighten-4' : 'red lighten-2'" class="elevation-5">
                        <v-toolbar dark color="primary">
                            <v-toolbar-title>{{$t('info_invitation')}}</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-btn
                                    class="align-self-end"
                                    color="red"
                                    icon
                                    @click="dialog_accesos_without_code = false">
                                <v-icon>close</v-icon>
                            </v-btn>
                        </v-toolbar>
                        <v-card-text>
                            <div class="text-xs-center">
                                <v-layout justify-center class="text-xs-center" row wrap>
                                    <v-flex xs12>
                                        <h2>{{$t('info_invitado')}}</h2>
                                        <br>
                                        <v-layout align-center justify-center row wrap>
                                            <v-flex class="text-xs-center" xs12 sm6>
                                              <v-img
                                                  :src="data_accesos_without_code.url_foto"
                                                  position="center center"
                                                  class="grey lighten-2"
                                              ></v-img>
                                            </v-flex>
                                            <v-flex class="text-xs-center" xs12 sm6>
                                                <table id="datas">
                                                    <tr>
                                                        <th>
                                                            <h2>
                                                                {{$t('Visitante')}}:
                                                            </h2>
                                                        </th>
                                                        <td>
                                                            <h2>
                                                                {{ data_accesos_without_code.nombre}}
                                                            </h2>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th>
                                                            <h2>
                                                                {{$t('Empresa')}}:
                                                            </h2>
                                                        </th>
                                                        <td>
                                                            <h2>
                                                                {{ data_accesos_without_code.empresa}}
                                                            </h2>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th>
                                                            <h2>
                                                                {{$t('Area')}}:
                                                            </h2>
                                                        </th>
                                                        <td>
                                                            <h2>
                                                                {{ data_accesos_without_code.areaName}}
                                                            </h2>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th>
                                                            <h2>
                                                                {{$t('Notas')}}
                                                            </h2>
                                                        </th>
                                                        <td>
                                                            <h2>
                                                                {{ data_accesos_without_code.notas}}
                                                            </h2>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th>
                                                            <h2>
                                                                {{$t('hora_acceso')}}
                                                            </h2>
                                                        </th>
                                                        <td>
                                                            <h2>
                                                                {{ data_accesos_without_code.f_acceso}}
                                                            </h2>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th>
                                                            <h2>
                                                                {{$t('hora_salida')}}
                                                            </h2>
                                                        </th>
                                                        <td>
                                                            <h2>
                                                                {{ data_accesos_without_code.f_salida ? data_accesos_without_code.f_salida : "Salida no registrada" }}
                                                            </h2>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th>
                                                            <h2>
                                                                {{$t('Anfitrion')}}
                                                            </h2>
                                                        </th>
                                                        <td>
                                                            <h2>
                                                                {{data_accesos_without_code.host}}
                                                            </h2>
                                                        </td>
                                                    </tr>
                                                </table>
                                            </v-flex>
                                        </v-layout>
                                    </v-flex>
                                </v-layout>
                            </div>
                        </v-card-text>
                        <v-card-actions class="justify-center">
                          <v-layout align-center justify-center row wrap>
                            <v-flex v-if="!dataAccessNoCode.pase_salida" xs12 class="text-xs-center">
                              <h3>{{$t('attemps')}} : {{dataAccessNoCode.count_pase_salida}}/2</h3>
                            </v-flex>
                            <v-flex xs12 class="text-xs-center">
                              <v-btn
                                  large
                                  color="error"
                                  @click="dialog_accesos_without_code = false"
                              >{{ $t('cerrar')}}
                              </v-btn>
                              <v-btn
                                  v-if="dataAccessNoCode.pase_salida"
                                  large
                                  color="success"
                                  :loading="loading"
                                  @click="create_check_out_access_no_code(dataAccessNoCode.id), dialog_accesos_without_code = false, entrada = false, salida = false"
                              >{{$t('registrar_salida')}}
                              </v-btn>
                              <v-btn
                                  v-if="!dataAccessNoCode.pase_salida && dataAccessNoCode.count_pase_salida !== 0 && countDownSign === 0"
                                  large
                                  color="primary"
                                  :loading="loading"
                                  @click="notificar_anfitrion_firmar(dataAccessNoCode.id)"
                              >
                                Notificar al anfitrión <br> firmar pase de salida
                              </v-btn>
                              <v-btn
                                      v-if="!dataAccessNoCode.pase_salida && dataAccessNoCode.count_pase_salida !== 0 && countDownSign > 0"
                                      large
                                      color="primary"
                              >
                                  Disponible en : {{countDownSign}}
                              </v-btn>
                              <v-btn
                                  v-if="!dataAccessNoCode.pase_salida && dataAccessNoCode.count_pase_salida === 0"
                                  large
                                  color="success"
                                  :loading="loading"
                                  @click="create_check_out_access_no_code(dataAccessNoCode.id), dialog_accesos_without_code = false, entrada = false, salida = false"
                              >{{$t('registrar_salida')}}
                              </v-btn>
                              <v-btn
                                  v-if="!dataAccessNoCode.pase_salida && dataAccessNoCode.count_pase_salida !== 0"
                                  large
                                  :loading="loadingCountInAccessNoCode"
                                  color="primary"
                                  @click="getRecordAccessNoCodeById(dataAccessNoCode.id)"
                              >
                                <v-icon>refresh</v-icon>
                              </v-btn>
                            </v-flex>
                          </v-layout>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
                <v-flex>
                    <v-card class="elevation-5">
                        <v-card-text>
                            <h3>{{$t('mostrando_historial_dia')}}</h3>
                            <v-form
                                    @submit.prevent="submit()">
                                <v-layout class="align-center " row wrap>
                                    <v-flex xs12 md6>
                                        <v-menu
                                                v-model="calendario"
                                                :close-on-content-click="false"
                                                :nudge-right="40"
                                                lazy
                                                transition="scale-transition"
                                                offset-y
                                                full-width
                                                min-width="290px"
                                        >
                                            <template v-slot:activator="{ on }">
                                                <v-text-field
                                                        v-model="computedInitialDateFormatted"
                                                        prepend-icon="event"
                                                        name="date"
                                                        :label="$t('Fecha_ini')"
                                                        :hint="$t('formato_fecha')"
                                                        persistent-hint
                                                        readonly
                                                        v-on="on"
                                                        :error-messages="errores.date"
                                                ></v-text-field>
                                            </template>
                                            <v-date-picker
                                                    :locale="$t('region')"
                                                    :min="get_current_date_menu()"
                                                    :max="get_current_date_menu2()"
                                                    v-model="date"
                                                    @input="calendario = false">
                                            </v-date-picker>
                                        </v-menu>
                                    </v-flex>
                                    <v-flex xs12 md6>
                                        <v-menu
                                                v-model="calendario2"
                                                :close-on-content-click="false"
                                                :nudge-right="40"
                                                lazy
                                                transition="scale-transition"
                                                offset-y
                                                full-width
                                                min-width="290px"
                                        >
                                            <template v-slot:activator="{ on }">
                                                <v-text-field
                                                        v-model="computedFinalDateFormatted"
                                                        prepend-icon="event"
                                                        name="date2"
                                                        :label="$t('Fecha_fin')"
                                                        :hint="$t('formato_fecha')"
                                                        persistent-hint
                                                        readonly
                                                        v-on="on"
                                                        :error-messages="errores.date2"
                                                ></v-text-field>
                                            </template>
                                            <v-date-picker
                                                    :locale="$t('region')"
                                                    :min="get_current_date_menu()"
                                                    :max="get_current_date_menu2()"
                                                    v-model="date2"
                                                    @input="calendario2 = false, submit()">
                                            </v-date-picker>
                                        </v-menu>
                                    </v-flex>
                                    <v-flex xs6>
                                        <v-btn
                                                color="primary"
                                                type="submit"
                                                large
                                        >{{ $t('Filtrar') }}
                                        </v-btn>
                                    </v-flex>
                                </v-layout>
                                <v-alert
                                        :value=alerta
                                        type="warning"
                                        outline
                                        transition="scale-transition"
                                >
                                    Fallo con el Servidor
                                </v-alert>
                            </v-form>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>


            <v-card class="my-2" v-show="getProfile.id_company !== 62">
                <v-toolbar dark color="primary">
                    <v-toolbar-title>
                        {{$t('access_log')}}
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-card-text>
                    <v-layout class="my-4" align-center justify-center fill-height>
                        <v-flex>
                            <v-data-table
                                    :headers="headersAccess2"
                                    :loading="loading_data_access2"
                                    :items="access"
                                    :rows-per-page-text="$t('filas_por_pagina')"
                                    :rows-per-page-items="[
                                                {text: '5', value: 5},
                                                {text: '10', value: 10},
                                                {text: '25', value: 25},
                                                {text: this.$t('todos'), value: -1}]"
                                    class="elevation-1"
                                    :no-data-text="$t('no_registros_accesos')"
                            >
                                <template v-slot:items="props">
                                    <td v-if="props.item.is_shipment || props.item.is_parking" style="text-align: center; padding: 8px;">
                                        <!-- Botón de Firmar Salida para embarques -->
                                        <v-btn
                                            v-if="props.item.is_shipment && props.item.status === 1 && !props.item.datetime_checkout"
                                            x-small
                                            color="success"
                                            @click="firmarSalidaEmbarque(props.item)"
                                            :loading="loadingFirmarSalida"
                                            title="Firmar Salida del Embarque"
                                            class="font-weight-bold"
                                        >
                                            <v-icon x-small left>exit_to_app</v-icon>
                                            Salida
                                        </v-btn>

                                        <!-- Mostrar hora si ya salió -->
                                        <v-chip
                                            v-else-if="props.item.is_shipment && props.item.datetime_checkout"
                                            x-small
                                            color="success"
                                            text-color="white"
                                            label
                                            class="elevation-2"
                                        >
                                            <v-icon x-small left>event_available</v-icon>
                                            {{ props.item.datetime_checkout }}
                                        </v-chip>

                                        <!-- Parking sin acción -->
                                        <span v-else-if="props.item.is_parking" class="grey--text">-</span>
                                    </td>
                                    <td v-else-if="props.item.access_qr_code === true && props.item.contractor === false" class="justify-center layout px-0">
                                        <v-tooltip
                                            v-if="props.item.download === null"
                                            bottom
                                        >
                                          <template v-slot:activator="{ on }">
                                            <v-icon
                                                large
                                                v-on="on"
                                                color="primary"
                                                @click="img = '', accessQRCode = props.item.access_qr_code, idAccess= props.item.id, accessContractor = props.item.contractor, bandTransportUpdate = true, cleanTransportFields(), dialogTransport = true"
                                            >
                                              local_shipping
                                            </v-icon>
                                          </template>
                                          <span>{{$t('add_carrier_data')}}</span>
                                        </v-tooltip>
                                        <v-tooltip
                                            v-else
                                            bottom
                                        >
                                          <template v-slot:activator="{ on }">
                                            <v-icon
                                                large
                                                v-on="on"
                                                color="success"
                                                @click="bandTransportUpdate = false, fillTransportFields(props.item), dialogTransport = true"
                                            >
                                              local_shipping
                                            </v-icon>
                                          </template>
                                          <span>{{$t('show_carrier_data')}}</span>
                                        </v-tooltip>
                                        <v-tooltip
                                            v-if="props.item.placas === null"
                                            bottom
                                        >
                                          <template v-slot:activator="{ on }">
                                            <v-icon
                                                large
                                                v-on="on"
                                                color="primary"
                                                @click="img = '', idAccess= props.item.id, dialogPlacas = true"
                                            >
                                              add_a_photo
                                            </v-icon>
                                          </template>
                                          <span>{{$t('agregar_placas')}}</span>
                                        </v-tooltip>
                                        <v-tooltip
                                            v-else
                                            bottom
                                        >
                                          <template v-slot:activator="{ on }">
                                            <v-icon
                                                large
                                                v-on="on"
                                                color="primary"
                                                @click="imagenPlacas = props.item.placas, dialogShowPlacas = true"
                                            >
                                              photo_camera
                                            </v-icon>
                                          </template>
                                          <span>{{$t('placas_mostrar')}}</span>
                                        </v-tooltip>
                                    </td>
                                    <td v-else-if="props.item.access_qr_code === true && props.item.contractor === true" class="justify-center layout px-0">
                                          <v-tooltip
                                              v-if="props.item.download === null"
                                              bottom
                                          >
                                            <template v-slot:activator="{ on }">
                                              <v-icon
                                                  large
                                                  v-on="on"
                                                  color="primary"
                                                  @click="img = '', idAccess= props.item.id, accessQRCode = props.item.access_qr_code, accessContractor = props.item.contractor, bandTransportUpdate = true, cleanTransportFields(), dialogTransport = true"
                                              >
                                                local_shipping
                                              </v-icon>
                                            </template>
                                            <span>{{$t('add_carrier_data')}}</span>
                                          </v-tooltip>
                                          <v-tooltip
                                              v-else
                                              bottom
                                          >
                                            <template v-slot:activator="{ on }">
                                              <v-icon
                                                  large
                                                  v-on="on"
                                                  color="success"
                                                  @click="bandTransportUpdate = false, fillTransportFields(props.item), dialogTransport = true"
                                              >
                                                local_shipping
                                              </v-icon>
                                            </template>
                                            <span>{{$t('show_carrier_data')}}</span>
                                          </v-tooltip>
                                          <!-- <v-btn
                                                  v-show="props.item.datetime_checkout === null"
                                                  color="primary"
                                                  class="mr-2"
                                                  @click="fill_fields(props.item)"
                                          >
                                              {{$t('entradas_salidas')}}
                                          </v-btn> -->
                                    </td>
                                    <td v-else class="justify-center layout px-0">
                                          <v-tooltip
                                              v-if="props.item.download === null"
                                              bottom
                                          >
                                            <template v-slot:activator="{ on }">
                                              <v-icon
                                                  large
                                                  v-on="on"
                                                  color="primary"
                                                  @click="img = '', idAccess= props.item.id, accessQRCode = props.item.access_qr_code, accessContractor = props.item.contractor, bandTransportUpdate = true, cleanTransportFields(), dialogTransport = true"
                                              >
                                                local_shipping
                                              </v-icon>
                                            </template>
                                            <span>{{$t('add_carrier_data')}}</span>
                                          </v-tooltip>
                                          <v-tooltip
                                              v-else
                                              bottom
                                          >
                                            <template v-slot:activator="{ on }">
                                              <v-icon
                                                  large
                                                  v-on="on"
                                                  color="success"
                                                  @click="bandTransportUpdate = false, fillTransportFields(props.item), dialogTransport = true"
                                              >
                                                local_shipping
                                              </v-icon>
                                            </template>
                                            <span>{{$t('show_carrier_data')}}</span>
                                          </v-tooltip>
                                          <v-btn
                                                  v-show="props.item.datetime_checkout === null"
                                                  color="primary"
                                                  class="mr-2"
                                                  @click="fill_fields(props.item)"
                                          >
                                              {{$t('entradas_salidas')}}
                                          </v-btn>
                                    </td>
                                    <td>
                                        <v-chip :color="props.item.type_invitation === 0 ? 'blue' : (props.item.type_invitation === 1 ? 'indigo' : (props.item.type_invitation === 2 ? 'purple' : (props.item.type_invitation === 3 ? 'teal' : (props.item.type_invitation === 4 ? 'brown' : (props.item.tipo_registro === 'Embarque' ? 'orange' : (props.item.is_parking ? 'green' : 'blue'))))))" text-color="white" small>
                                            {{ props.item.type_invitation_text || props.item.tipo_registro }}
                                        </v-chip>
                                    </td>
                                    <td>{{ props.item.access_qr_code === true ? $t('acceso_con_codigo')  :  $t('acceso_sin_codigo') }}</td>
                                    <td>{{ props.item.guest_full_name }}</td>
                                    <td>{{ (props.item.company_name === null || props.item.company_name === '') ? 'n/a' : props.item.company_name}}</td>
<!--                                            <td>{{ props.item.health_survey ? props.item.temperature : 'n/a' }}</td>-->
                                    <td>
<!--                                              <v-alert-->
<!--                                                  class="mr-2"-->
<!--                                                  v-show="props.item.status === 0"-->
<!--                                                  type="info">-->
<!--                                                {{$t('pending_authorization')}}-->
<!--                                              </v-alert>-->
                                      <v-alert
                                          class="mr-2"
                                          v-show="props.item.status === 0 && props.item.authorized === false"
                                          type="info">
                                        {{$t('pending_authorization')}}
                                      </v-alert>
                                      <v-alert
                                          class="mr-2"
                                          v-show="props.item.status === 0 && props.item.authorized === true"
                                          type="info">
                                        {{$t('authorized_access')}}
                                      </v-alert>
                                      <v-alert
                                          class="mr-2"
                                          v-show="props.item.status === 1"
                                          type="success">
                                        {{$t('adentro')}}
                                      </v-alert>
                                      <v-alert
                                          class="mr-2"
                                          v-show="props.item.status === 2 && props.item.exit_pass === true"
                                          type="info">
                                        {{$t('completado')}}
                                      </v-alert>
                                      <v-alert
                                          class="mr-2"
                                          v-show="props.item.status === 2 && props.item.exit_pass === false"
                                          type="warning">
                                        {{$t('no_firmado')}}/
                                        {{$t('completado')}}
                                      </v-alert>
                                      <v-alert
                                          class="mr-2"
                                          v-show="props.item.status === 3"
                                          type="warning">
                                          {{$t('no_firmado')}}/
                                          {{$t('completado')}}
                                      </v-alert>
                                      <v-alert
                                          class="mr-2"
                                          v-show="props.item.status === 4"
                                          type="error">
                                        {{$t('deny')}}
                                      </v-alert>
                                      <v-alert
                                          class="mr-2"
                                          v-show="props.item.status === 5"
                                          type="info">
                                        {{$t('waiting_room')}}
                                      </v-alert>
                                    </td>
                                    <td>{{ props.item.datetime_arrival | stringToTime }}</td>
                                    <td>
                                        <template v-if="props.item.datetime_checkin">
                                            {{ props.item.datetime_checkin | stringToTime }}
                                        </template>
                                        <template v-else>
                                            {{ $t('pendiente') }}
                                        </template>
                                    </td>
                                    <td>
                                        <template v-if="props.item.datetime_checkout">
                                            {{ props.item.datetime_checkout | stringToTime }}
                                        </template>
                                        <template v-else>
                                            {{ $t('pendiente') }}
                                        </template>
                                    </td>
                                    <td>{{ props.item.host_full_name}}</td>
                                </template>
                                <template v-slot:pageText="props">
                                    {{props.rowsPerPage}}
                                            <vue-excel-xlsx
                                                    :data="accessForExcel"
                                                    :columns="headersAccessExcel"
                                                    :file-name="'access' + '_' + date + '_' + date2"
                                                    :sheet-name="$t('headerAccess')"
                                            >
                                                <v-btn
                                                    color="primary"
                                                >
                                                    {{$t('export_to_excel')}}
                                                </v-btn>
                                            </vue-excel-xlsx>
                                            <v-btn
                                                    color="primary"
                                                    @click="exportPdfAccessUnion"
                                            >
                                                    {{$t('export_to_pdf')}}
                                            </v-btn>
                                    {{$t('Accesos')}} {{ props.pageStart }} - {{ props.pageStop }} {{$t('prep_de')}} {{ props.itemsLength }}
                                </template>
                            </v-data-table>
                        </v-flex>
                    </v-layout>
                </v-card-text>
            </v-card>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-card class="my-2" v-show="getProfile.id_company === 62">
                <v-toolbar dark color="primary">
                    <v-toolbar-title>
                        {{$t('historial_accesos_sin_codigo')}}
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-card-text>
                    <v-layout class="my-4" align-center justify-center fill-height>
                        <v-flex >
                            <v-card-title>
                              <v-text-field
                                  v-model="search3"
                                  append-icon="search"
                                  :label="$t('Buscar')"
                                  single-line
                                  hide-details
                              ></v-text-field>
                            </v-card-title>
                            <v-data-table
                                    :headers="headers5"
                                    :loading="loading_data_accesos_no_code_express"
                                    :items="accesos_no_code_express"
                                    :search="search3"
                                    :rows-per-page-text="$t('filas_por_pagina')"
                                    :rows-per-page-items="[
                                        {text: '10', value: 10},
                                        {text: '20', value: 20},
                                        {text: '50', value: 50},
                                        {text: this.$t('todos'), value: -1}
                                    ]"
                                    class="elevation-1"
                                    :no-data-text="$t('no_registros_accesos')"
                            >
                                <template v-slot:no-results>
                                    <v-alert :value="true" color="error" class="white--text" icon="warning">
                                        {{$t('ningun_resultado_1')}} "{{ search3 }}" {{$t('ningun_resultado_2')}}
                                    </v-alert>
                                </template>
                                <template v-slot:items="props">
                                    <td class="justify-center layout px-0">
                                        <v-icon
                                                medium
                                                class="mr-2"
                                                @click="fill_fields_express(props.item),
                                                dialog_accesos_no_code_express = true"
                                        >
                                            search
                                        </v-icon>
                                    </td>
                                    <td>{{ props.item.nombre }}</td>
                                    <td>{{ props.item.f_acceso }}</td>
                                    <td v-if="props.item.f_salida === null">
                                      <v-btn
                                          v-if="getProfile.roll === 2"
                                          color="primary"
                                          @click="firmar_express(props.item.id)">
                                        {{$t('firmar')}}
                                      </v-btn>
                                      <v-btn
                                          v-else
                                          disabled
                                          color="primary"
                                          @click="firmar_express(props.item.id)">
                                        {{$t('firmar')}}
                                      </v-btn>
                                    </td>
                                    <td v-else>
                                        {{ props.item.f_salida }}
                                    </td>
                                </template>
                                <template v-slot:pageText="props">
                                    {{props.rowsPerPage}}
                                      <vue-excel-xlsx
                                              :data="accesos_no_code_express"
                                              :columns="headersAccessNoCodeExpressExcel"
                                              :file-name="'accessNoCode' + '_' + date + '_' + date2"
                                              :sheet-name="$t('headerAccessNoCodeExcel')"
                                      >
                                          <v-btn
                                              v-if="getProfile.roll === 5"
                                              color="primary"
                                          >
                                              {{$t('export_to_excel')}}
                                          </v-btn>
                                      </vue-excel-xlsx>
                                      <v-btn
                                          v-if="getProfile.roll === 5"
                                          color="primary"
                                          @click="exportPdfExpressAccess"
                                      >
                                        {{$t('export_to_pdf')}}
                                      </v-btn>
                                    {{$t('Accesos')}} {{ props.pageStart }} - {{ props.pageStop }} {{$t('prep_de')}} {{ props.itemsLength }}
                                </template>
                            </v-data-table>
                        </v-flex>
                    </v-layout>
                </v-card-text>
            </v-card>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
        </v-container>
    </div>
</template>

<script>
    import { WebCam } from "vue-web-cam"
    import '@/plugins/axios'
    import store from '@/store'
    import {mapState} from 'vuex'
    import jsPDF from 'jspdf'
    import 'jspdf-autotable'
    import { mapGetters } from 'vuex'

    export default {
        name: "bitacora",
        components: {
            "vue-web-cam": WebCam
        },
        data: () => ({
            alerta: false,
            calendario: false,
            calendario2: false,
            fecha_actual: '',
            date: '',
            date2: '',
            errores: [],
            search: '',
            searchDataParking: '',
            headers4: [],
            headers5: [],
            invitaciones:[],
            accesos_without_code: [],
            accesos_no_code_express: [],
            loading_data_invitaciones: false,
            loading_data_accesos_without_code: false,
            loading_data_accesos_no_code_express: false,
            loading_data_parking: false,
            yyyy: '',
            mm: '',
            dd: '',
            yyyy2: '',
            mm2: '',
            dd2: '',
            dialog_accesos_without_code: false,
            dialog_accesos_no_code_express: false,
            headersAccess: [],
            loading_data_accesos: false,
            accesos: [],
            headersAccessExcel: [],
            headersAccessNoCodeExcel: [],
            headersAccessNoCodeExpressExcel: [],
            data_accesos_without_code: [],
            data_accesos_no_code_express: [],
            band: false,
            search3: '',
            img: '',
            camera: null,
            deviceId: null,
            devices: [],
            dialogPlacas: false,
            loading: false,
            idAccess: '',
            idAccessNoCode: '',
            dialogShowPlacas: false,
            imagenPlacas: '',
            countDownAuthorized: 0,
            countDownPass: 0,
            dialog_errores: false,
            errores_guard: '',
            head_color: '',
            band_gafete: false,
            loading_gafete: false,
            salida: false,
            entrada: false,
            loadingCountInAccessNoCode: false,
            dataAccessNoCode: {},
            countDownAuthorizedAccessNoCode: 0,
            dialog_inicio: false,
            casetas: [],
            access: [],
            loading_data_access2: false,
            headersAccess2: [],
            headersParkingAccess: [],
            countDownSign: 0,
            caseta: 0,
            typeService: null,
            case_plates: '',
            container_platform_plates: '',
            transport_line: '',
            supplier_customer_name: '',
            bandTransportUpdate: false,
            bandConfirm: false,
            dialogTransport: false,
            accessQRCode: false,
            accessContractor: false,
            dataAccessParking: [],
            id_empresa: '',
            loadingFirmarSalida: false,
        }),
        created: function(){
            this.get_extra_data()
            this.get_casetas()
            this.fecha_actual = this.get_current_date()
            this.date = this.fecha_actual
            this.date2 = this.fecha_actual
            if(!this.getProfile.enable_parking && localStorage.getItem('id_caseta') === null){
            this.dialog_inicio = true
            }
            // get_access_union_by_date se llama desde get_extra_data para garantizar que id_empresa esté disponible
            this.get_access_no_code_express_by_date(this.yyyy, this.mm, this.dd, this.yyyy2, this.mm2, this.dd2)
        },
        beforeUpdate() {
            this.headersParkingAccess = [
                {
                    text: this.$t('Visitante'),
                    align: 'left',
                    sortable: true,
                    value: 'guest_name'
                },
                {
                    text: this.$t('assigned_parking_space'),
                    align: 'left',
                    sortable: true,
                    value: 'space_number'
                },
                {
                    text: this.$t('estado'),
                    align: 'center',
                    sortable: true,
                    value: 'access_type'
                },
                {
                    text: this.$t('hora_acceso'),
                    align: 'left',
                    sortable: true,
                    value: 'access_time'
                },
                {
                    text: this.$t('hora_salida'),
                    align: 'left',
                    sortable: true,
                    value: 'exit_time'
                },
                {
                    text: this.$t('Vigilante'),
                    align: 'left',
                    sortable: true,
                    value: 'registered_by_name'
                },
            ]
            this.headersAccess2 = [
                {
                    text: this.$t('acciones'),
                    align: 'center',
                    sortable: false,
                    value: 'update'
                },
                {
                    text: 'Tipo',
                    align: 'left',
                    sortable: true,
                    value: 'tipo_registro'
                },
                {
                    text: this.$t('type_of_access'),
                    align: 'left',
                    sortable: true,
                    value: 'access_qr_code'
                },
                {
                    text: this.$t('Visitante'),
                    align: 'left',
                    sortable: true,
                    value: 'guest_full_name'
                },
                {
                    text: this.$t('Empresa'),
                    align: 'left',
                    sortable: true,
                    value: 'company_name'
                },
                {
                    text: this.$t('estado'),
                    align: 'center',
                    sortable: true,
                    value: 'status'
                },
                {
                    text: this.$t('hora_llegada'),
                    align: 'left',
                    sortable: true,
                    value: 'datetime_arrival'
                },
                {
                    text: this.$t('hora_acceso'),
                    align: 'left',
                    sortable: true,
                    value: 'datetime_checkin'
                },
                {
                    text: this.$t('hora_salida'),
                    align: 'left',
                    sortable: true,
                    value: 'datetime_checkout'
                },
                {
                    text: this.$t('Anfitrion'),
                    align: 'left',
                    sortable: true,
                    value: 'host_full_name'
                }
            ],
            this.headersAccess = [
                {
                    text: this.$t('acciones'),
                    align: 'center',
                    sortable: false,
                    value: 'update'
                },
                {
                    text: this.$t('Visitante'),
                    align: 'left',
                    sortable: true,
                    value: 'invitado'
                },
                {
                    text: this.$t('Empresa'),
                    align: 'left',
                    sortable: true,
                    value: 'empresa'
                },
                {
                    text: this.$t('temperature'),
                    align: 'left',
                    sortable: true,
                    value: 'temperature'
                },
                {
                    text: this.$t('estado'),
                    align: 'left',
                    sortable: true,
                    value: 'estado'
                },
                {
                    text: this.$t('hora_acceso'),
                    align: 'left',
                    sortable: true,
                    value: 'fecha_hora_acceso'
                },
                {
                    text: this.$t('hora_salida'),
                    align: 'left',
                    sortable: true,
                    value: 'fecha_hora_salida'
                },
                {
                    text: this.$t('Anfitrion'),
                    align: 'left',
                    sortable: true,
                    value: 'id_invitacion'
                }
            ],
            this.headersAccessExcel = [
                {
                    label: 'Tipo',
                    field: 'tipo_registro'
                },
                {
                    label: this.$t('type_of_access'),
                    field: 'access_qr_code',
                    dataFormat: this.typeAccessFormat
                },
                {
                    label: this.$t('Visitante'),
                    field: 'guest_full_name'
                },
                {
                    label: this.$t('Empresa'),
                    field: 'company_name',
                },
                {
                    label: this.$t('estado'),
                    field: 'status',
                    dataFormat: this.estadoFormat
                },
                {
                    label: this.$t('hora_llegada'),
                    field: 'datetime_arrival'
                },
                {
                    label: this.$t('hora_acceso'),
                    field: 'datetime_checkin'
                },
                {
                    label: this.$t('hora_salida'),
                    field: 'datetime_checkout'
                },
                {
                    label: this.$t('Anfitrion'),
                    field: 'host_full_name'
                }
            ],
            this.headers4 = [
                {
                    text: this.$t('acciones'),
                    align: 'center',
                    sortable: false,
                    value: 'acciones'
                },
                {
                    text: this.$t('estado'),
                    align: 'center',
                    sortable: true,
                    value: 'estado'
                },
                {
                    text: this.$t('Visitante'),
                    align: 'left',
                    sortable: true,
                    value: 'nombre'
                },
                {
                    text: this.$t('Empresa'),
                    align: 'left',
                    sortable: true,
                    value: 'empresa'
                },
                {
                    text: this.$t('hora_acceso'),
                    align: 'left',
                    sortable: true,
                    value: 'f_acceso'
                },
                {
                    text: this.$t('hora_salida'),
                    align: 'left',
                    sortable: true,
                    value: 'f_salida'
                },
                {
                    text: this.$t('Anfitrion'),
                    align: 'left',
                    sortable: true,
                    value: 'nombree'
                }
            ],
            this.headers5 = [
                {
                    text: this.$t('detalle'),
                    align: 'center',
                    sortable: false,
                    value: 'details'
                },
                {
                    text: this.$t('Visitante'),
                    align: 'left',
                    sortable: true,
                    value: 'nombre'
                },
                {
                    text: this.$t('hora_acceso'),
                    align: 'left',
                    sortable: true,
                    value: 'f_acceso'
                },
                {
                    text: this.$t('hora_salida'),
                    align: 'left',
                    sortable: true,
                    value: 'f_salida'
                }
            ],
            this.headersAccessNoCodeExcel = [
                {
                    label: this.$t('Visitante'),
                    field: 'nombre'
                },
                {
                    label: this.$t('Empresa'),
                    field: 'empresa',
                },
                {
                    label: this.$t('hora_acceso'),
                    field: 'f_acceso'
                },
                {
                    label: this.$t('hora_salida'),
                    field: 'f_salida'
                },
                {
                    label: this.$t('Anfitrion'),
                    field: 'hostFirstName'
                }
            ]
            this.headersAccessNoCodeExpressExcel = [
                {
                    label: this.$t('Visitante'),
                    field: 'nombre'
                },
                {
                    label: this.$t('Area'),
                    field: 'areaName',
                },
                {
                    label: this.$t('hora_acceso'),
                    field: 'f_acceso'
                },
                {
                    label: this.$t('hora_salida'),
                    field: 'f_salida'
                },
                {
                    label: this.$t('Notas'),
                    field: 'notas'
                }
            ]
        },
        computed: {
            ...mapState(['language']),
            ...mapGetters(['getProfile']),
            computedInitialDateFormatted () {
                return this.formatDate(this.date)
            },
            computedFinalDateFormatted () {
                return this.formatDate(this.date2)
            },
            accessForExcel () {
                return this.access.map(item => {
                    if (item.status === 2 && item.exit_pass === false) {
                        return { ...item, status: 3 }
                    }
                    return item
                })
            },
            device () {
                return this.devices.find(n => n.deviceId === this.deviceId)
            }
        },
        watch: {
            camera: function(id) {
                this.deviceId = id
            },
            devices () {
                // Once we have a list select the first one
                const [first, ...tail] = this.devices
                if (first) {
                    this.camera = first.deviceId
                    this.deviceId = first.deviceId
                }else {
                    this.camera = tail.deviceId
                    this.deviceId = tail.deviceId
                }
            }
        },
        methods:{
            firmarSalidaEmbarque(item) {
                if (!item.qr_code) {
                    this.$store.commit('snackbar_activate_true')
                    this.$store.commit('snackbar_change_message', 'QR code no disponible')
                    this.$store.commit('snackbar_change_color', 'error')
                    return
                }

                this.loadingFirmarSalida = true

                const config = {
                    method: 'post',
                    url: 'https://empresa-service.intrare.app/shipments/guard/register-exit/',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    },
                    data: {
                        qr_code: item.qr_code
                    }
                }

                axios(config)
                    .then(response => {
                        this.loadingFirmarSalida = false

                        // Actualizar el item en la tabla
                        item.status = 2  // Cambiar a "completed"
                        item.datetime_checkout = response.data.fecha_hora_salida || new Date().toLocaleString('es-ES')

                        // Mostrar éxito
                        this.$store.commit('snackbar_activate_true')
                        this.$store.commit('snackbar_change_message', 'Salida del embarque registrada exitosamente')
                        this.$store.commit('snackbar_change_color', 'success')

                        // Opcional: si hay URL de CAV para imprimir
                        if (response.data.cav_print_url) {
                            window.open(response.data.cav_print_url, '_blank')
                        }
                    })
                    .catch(error => {
                        this.loadingFirmarSalida = false

                        let errorMsg = 'Error al registrar salida'
                        if (error.response && error.response.data && error.response.data.error) {
                            errorMsg = error.response.data.error
                        }

                        this.$store.commit('snackbar_activate_true')
                        this.$store.commit('snackbar_change_message', errorMsg)
                        this.$store.commit('snackbar_change_color', 'error')

                        console.error('Error:', error)
                    })
            },
            get_extra_data (){
                this.loading_data_parking = true
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/auth/me',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };
                axios(config)
                    .then(response => {
                        this.id_empresa = response.data.id_company
                        this.get_access_union_by_date(this.yyyy, this.mm, this.dd, this.yyyy2, this.mm2, this.dd2)
                    })
                    .catch(error => {
                        console.log(error)
                    })
            },
            cleanTransportFields () {
              this.typeService = null
              this.case_plates = null
              this.container_platform_plates = null
              this.transport_line = null
              this.supplier_customer_name = null
            },
            fillTransportFields (item) {
              this.typeService = item.download
              this.case_plates = item.case_plates
              this.container_platform_plates = item.container_platform_plates
              this.transport_line = item.transport_line
              this.supplier_customer_name = item.supplier_customer_name
            },
            exportPdfAccessUnion () {
                var fechaInicial = this.formatDate(this.date)
                var fechaFinal = this.formatDate(this.date2)
                var adentro = this.$t('adentro')
                var pending_authorization = this.$t('pending_authorization')
                var completado = this.$t('completado')
                var waiting_room = this.$t('waiting_room')
                var no_firmado_completado = this.$t('no_firmado') + '/' + this.$t('completado')
                var denegado = this.$t('deny')
                var headerAccessNoCode = this.$t('headerAccess')
                var pendiente = this.$t('pendiente')
                var period = this.$t('period')
                var al = this.$t('al')
                var page = this.$t('page')
                var de = this.$t('de')
                var con_codigo = this.$t('acceso_con_codigo')
                var sin_codigo = this.$t('acceso_sin_codigo')
                var total = 'Total: ' + this.access.length.toString()
                var columns = [{
                    tipo_registro: 'Tipo',
                    access_qr_code: this.$t('type_of_access'),
                    guest_full_name: this.$t('Visitante'),
                    company_name: this.$t('Empresa'),
                    status: this.$t('estado'),
                    datetime_arrival: this.$t('hora_llegada'),
                    datetime_checkin: this.$t('hora_acceso'),
                    datetime_checkout: this.$t('hora_salida'),
                    host_full_name: this.$t('Anfitrion'),
                }]
                var doc = new jsPDF("landscape", "pt", "letter")
                var totalPagesExp = '{total_pages_count_string}'
                doc.autoTable({
                    head: columns,
                    body: this.access,
                    didDrawPage: function (data) {
                        // Header
                        doc.setFontSize(20)
                        doc.setTextColor(40)
                        doc.setFontStyle('normal')
                        // if (base64Img) {
                        //     doc.addImage(base64Img, 'JPEG', data.settings.margin.left, 15, 10, 10)
                        // }
                        doc.text(headerAccessNoCode, data.settings.margin.left + 20, 38)
                        doc.text(period + fechaInicial + al + fechaFinal, data.settings.margin.left + 20, 60)
                        doc.text(total, data.settings.margin.left + 20, 82)

                        // Footer
                        var str = page + doc.internal.getNumberOfPages()
                        // Total page number plugin only available in jspdf v1.0+
                        if (typeof doc.putTotalPages === 'function') {
                            str = str + de + totalPagesExp
                        }
                        doc.setFontSize(10)

                        // jsPDF 1.4+ uses getWidth, <1.4 uses .width
                        var pageSize = doc.internal.pageSize
                        var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
                        doc.text(str, data.settings.margin.left, pageHeight - 10)
                    },
                    allSectionHooks: true,
                    didParseCell: function (data) {
                        if (data.row.section === 'body') {
                          if (data.column.index === 1) {
                            if (data.cell.text.toString() === 'true') {
                              data.cell.text = con_codigo
                            } else {
                              data.cell.text = sin_codigo
                            }
                          }
                          if (data.column.index === 7) {
                            if (data.cell.text.toString() === '') {
                              data.cell.text = pendiente
                            }
                          }
                          if (data.column.index === 6) {
                            if (data.cell.text.toString() === '') {
                              data.cell.text = pendiente
                            }
                          }
                          if (data.column.index === 4) {
                            if (data.cell.text.toString() === '0') {
                              data.cell.text = pending_authorization
                            }
                            if (data.cell.text.toString() === '1') {
                              data.cell.text = adentro
                            }
                            if (data.cell.text.toString() === '2') {
                              if (data.row.raw.exit_pass === true) {
                                data.cell.text = completado
                              } else {
                                data.cell.text = no_firmado_completado
                              }
                            }
                            if (data.cell.text.toString() === '3') {
                              data.cell.text = no_firmado_completado
                            }
                            if (data.cell.text.toString() === '4') {
                              data.cell.text = denegado
                            }
                            if (data.cell.text.toString() === '5') {
                              data.cell.text = waiting_room
                            }
                          }
                        }
                    },
                    margin: { top: 90 }
                })
                // Total page number plugin only available in jspdf v1.0+
                if (typeof doc.putTotalPages === 'function') {
                    doc.putTotalPages(totalPagesExp)
                }
                doc.save('access' + '_' + this.date + '_' + this.date2 + '.pdf')
            },
            get_casetas: function(){
              this.$store.dispatch('security/FETCH_MY_CASETAS', store.getters.getToken)
                  .then(response => {
                    // Manejar múltiples formatos de respuesta
                    if (response && response.casetas && Array.isArray(response.casetas)) {
                      this.casetas = response.casetas
                    } else if (Array.isArray(response)) {
                      this.casetas = response
                    } else if (response && response.data && Array.isArray(response.data)) {
                      this.casetas = response.data
                    }
                    if (this.getProfile.enable_parking && localStorage.getItem('id_caseta') === null) {
                      const casetasActivas = this.casetas.filter(c => c.activa)
                      if (casetasActivas.length === 1) {
                        const casetaId = casetasActivas[0].id
                        localStorage.setItem('id_caseta', casetaId)
                        this.caseta = casetaId
                        this.dialog_inicio = false
                        this.$store.commit('snackbar_activate_true')
                        this.$store.commit('snackbar_change_color', 'success')
                        this.$store.commit('snackbar_change_message', 'Caseta seleccionada correctamente')
                      }
                    }
                  })
                  .catch(error => {
                    console.log(error)
                  })
            },
            set_caseta: function(){
              if(this.caseta > 0){
                localStorage.setItem('id_caseta', this.caseta)
                this.dialog_inicio = false
              }
            },
            countDownTimerAccessNoCode(id) {
              if(this.countDownAuthorizedAccessNoCode > 0) {
                setTimeout(() => {
                  this.countDownAuthorizedAccessNoCode -= 1
                  this.countDownTimerAccessNoCode(id)
                }, 1000)
              } else {
                const config2 = {
                  method: 'get',
                  url: 'https://empresa-service.intrare.app/bitacora/' + id,
                  headers: {
                    'Content-Type': 'application/json',
                    'Accept-Language': this.language,
                  },
                };
                axios(config2)
                    .then(ok => {
                      this.dataAccessNoCode = ok.data[0]
                      console.log('Datos devueltos por Servidor DESPUES DE NOTIFICAR POR SEGUNDA OCASION AL ANFITRION')
                      console.log(this.dataAccessNoCode)
                      console.log('Id = ', this.dataAccessNoCode.id)
                    })
                    .catch(error => {
                      console.log(error)
                    })
              }
            },
            countDownSignTimer() {
                if(this.countDownSign > 0) {
                    setTimeout(() => {
                        this.countDownSign -= 1
                        this.countDownSignTimer()
                    }, 1000)
                }
            },
            getRecordAccessNoCodeById(id) {
              this.loadingCountInAccessNoCode = true
              const config = {
                method: 'get',
                url: 'https://empresa-service.intrare.app/bitacora/' + id,
                headers: {
                  'Content-Type': 'application/json',
                  'Accept-Language': this.language,
                },
              };
              axios(config)
                  .then(ok => {
                    this.loadingCountInAccessNoCode = false
                    this.dataAccessNoCode = ok.data[0]
                    if (this.dataAccessNoCode.estado === 0 || this.dataAccessNoCode.estado === 5) {
                      this.entrada = true
                      this.salida = false
                    } else {
                      this.entrada = false
                      this.salida = true
                    }
                  })
                  .catch(error => {
                    this.loadingCountInAccessNoCode = false
                    console.log(error)
                  })
            },
            getRecordAccessNoCodeByIdLoading(id) {
              this.loadingCountInAccessNoCode = true
              const config = {
                method: 'get',
                url: 'https://empresa-service.intrare.app/bitacora/' + id,
                headers: {
                  'Content-Type': 'application/json',
                  'Accept-Language': this.language,
                },
              };
              axios(config)
                  .then(ok => {
                    this.loadingCountInAccessNoCode = false
                    this.dataAccessNoCode = ok.data[0]
                    if (this.dataAccessNoCode.estado === 0 || this.dataAccessNoCode.estado === 5) {
                      this.entrada = true
                      this.salida = false
                    } else {
                      this.entrada = false
                      this.salida = true
                    }
                    this.data_accesos_without_code = this.dataAccessNoCode
                    this.dialog_accesos_without_code = true
                    console.log(this.data_accesos_without_code)
                  })
                  .catch(error => {
                    this.loadingCountInAccessNoCode = false
                    console.log(error)
                  })
            },
            notificar_anfitrion_acceso_sin_codigo(id){
              this.loading = true
              console.log('Avisar al Anfitrión que autorize el acceso sin codigo dela persona = ', id)
              const config = {
                method: 'get',
                url: 'https://empresa-service.intrare.app/notifyAuthorizedAccessNoCode/' + id + '/',
                headers: {
                  'Content-Type': 'application/json',
                }
              };
              axios(config)
                  .then(response => {
                    this.loading = false
                    this.countDownAuthorizedAccessNoCode = 30
                    this.countDownTimerAccessNoCode(id)
                    this.$store.commit('snackbar_activate_true')
                    this.$store.commit('snackbar_change_color', 'success')
                    this.$store.commit('snackbar_change_message', this.$t('msg_notificacion_anfitrion'))
                    setTimeout(this.clear3, 3000)
                  })
                  .catch(error => {
                    this.loading = false
                    console.log(error)
                  })
            },
            countDownTimer() {
                if(this.countDownAuthorized > 0) {
                    setTimeout(() => {
                        this.countDownAuthorized -= 1
                        this.countDownTimer()
                    }, 1000)
                }
            },
            countDownPassTimer() {
                if(this.countDownPass > 0) {
                    setTimeout(() => {
                        this.countDownPass -= 1
                        this.countDownPassTimer()
                    }, 1000)
                }
            },
            notificar_anfitrion_acceso(){
                this.loading = true
                console.log('Avisar al Anfitrión que autorize el acceso sin codigo dela persona = ', this.idAccessNoCode)
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/notifyAuthorizedAccessNoCode/' + this.idAccessNoCode + '/',
                    headers: {
                        'Content-Type': 'application/json',
                    }
                };
                axios(config)
                    .then(response => {
                        this.loading = false
                        this.countDownAuthorized = 30
                        this.countDownTimer()
                        this.$store.commit('snackbar_activate_true')
                        this.$store.commit('snackbar_change_color', 'success')
                        this.$store.commit('snackbar_change_message', this.$t('msg_notificacion_anfitrion'))
                        setTimeout(this.clear, 3000)
                    })
                    .catch(error => {
                        this.loading = false
                        console.log(error)
                    })
            },
            notificar_anfitrion_firmar(id){
                this.loading = true
                console.log('Avisar al Anfitrión que firme el pase de salida del acceso sin codigo = ', id)
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/notifySignExitPassAccessNoCode/' + id + '/',
                    headers: {
                        'Content-Type': 'application/json',
                    }
                };
                axios(config)
                    .then(response => {
                        this.loading = false
                        this.countDownSign = 30
                        this.countDownSignTimer()
                        this.$store.commit('snackbar_activate_true')
                        this.$store.commit('snackbar_change_color', 'success')
                        this.$store.commit('snackbar_change_message', this.$t('msg_notificacion_anfitrion'))
                        const config2 = {
                          method: 'get',
                          url: 'https://empresa-service.intrare.app/bitacora/' + id,
                          headers: {
                            'Content-Type': 'application/json',
                            'Accept-Language': this.language,
                          },
                        };
                        axios(config2)
                            .then(ok => {
                              this.dataAccessNoCode = ok.data[0]
                              console.log('Datos devueltos por Servidor DESPUES DE NOTIFICAR POR SEGUNDA OCASION AL ANFITRION')
                              console.log(this.dataAccessNoCode)
                              console.log('Id = ', this.dataAccessNoCode.id)
                            })
                            .catch(error => {
                              console.log(error)
                            })
                    })
                    .catch(error => {
                        this.loading = false
                        console.log(error)
                    })
            },
            create_check_out_access_no_code (id) {
                this.loading = true
                const config = {
                    method: 'patch',
                    url: 'https://empresa-service.intrare.app/registrar_salida/' + id + '/',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    },
                    data: {
                      id_guardhouse_checkout: localStorage.getItem('id_caseta')
                    }
                }
                axios(config)
                    .then(response => {
                        this.loading = false
                        this.errores_guard =this.$t('mensaje_alta_acceso_out')
                        this.head_color = 'green display-1 text--primary'
                        this.dialog_errores = true
                        this.get_access_union_by_date(this.yyyy, this.mm, this.dd, this.yyyy2, this.mm2, this.dd2)
                    })
                    .catch(error => {
                        this.loading = false
                        console.log(error.response.data)
                        this.head_color = 'red display-1 text--primary'
                        this.errores_guard = error.response.data.error
                        this.dialog_errores = true
                    })
            },
            create_access_no_code (id) {
                this.loading = true
                const config = {
                    method: 'patch',
                    url: 'https://empresa-service.intrare.app/update_access_no_code/' + id + '/',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    },
                    data:{
                      id_guardhouse_checkin: localStorage.getItem('id_caseta')
                    }
                }
                axios(config)
                    .then(response => {
                        this.loading = false
                        this.errores_guard =this.$t('mensaje_alta_acceso_in')
                        this.head_color = 'green display-1 text--primary'
                        this.band_gafete = true
                        this.dialog_errores = true
                        this.getRecordAccessNoCodeById(id)
                        this.get_access_union_by_date(this.yyyy, this.mm, this.dd, this.yyyy2, this.mm2, this.dd2)
                    })
                    .catch(error => {
                        this.loading = false
                        console.log(error.response.data)
                        this.head_color = 'red display-1 text--primary'
                        this.errores_guard = error.response.data.error
                        this.dialog_errores = true
                    })
            },
            xOffset: function(pdf, text){
                console.log('Page width =', pdf.internal.pageSize.width)
                console.log('text width =', pdf.getStringUnitWidth(text))
                console.log('Font width =', pdf.internal.getFontSize())
                return ((pdf.internal.pageSize.width / 2) - (pdf.getStringUnitWidth(text) * pdf.internal.getFontSize() / 2) / 72.0)
            },
            download_gafete (fullname_guest, fullname_host, date, company_logo){
                const toDataUrl = (url, callback) => {
                    const xhr = new XMLHttpRequest();
                    xhr.onload = () => {
                        const reader = new FileReader();
                        reader.onloadend = () => {
                            callback(reader.result);
                        };
                        reader.readAsDataURL(xhr.response);
                    };
                    xhr.open('GET', url);
                    xhr.responseType = 'blob';
                    xhr.send();
                };
                var pdf = new jsPDF('l', 'in', [288, 144])
                // Black square with rounded corners
                pdf.setDrawColor(0)
                pdf.setFontSize(9)
                pdf.text(this.$t('fecha_hora_acceso'),
                    2.3,
                    0.4)
                pdf.setLineWidth(0.02)
                pdf.line(2.3, 0.42, 3.7, 0.42)
                pdf.setFontStyle("normal")
                pdf.text(date,
                    2.7,
                    0.6)
                pdf.setFontSize(14)
                pdf.line(this.xOffset(pdf, this.$t('Visitante').toUpperCase()), 0.92, 2.6, 0.92)
                pdf.setFontStyle("bold")
                pdf.text(this.$t('Visitante').toUpperCase(),
                    this.xOffset(pdf, this.$t('Visitante').toUpperCase()),
                    0.9)
                pdf.setFontSize(16)
                pdf.setFontStyle("normal")
                pdf.text(fullname_guest,
                    this.xOffset(pdf, fullname_guest),
                    1.2)
                pdf.line(this.xOffset(pdf, this.$t('Anfitrion').toUpperCase()), 1.47, 2.6, 1.47)
                pdf.setFontSize(14)
                pdf.setFontStyle("bold")
                pdf.text(this.$t('Anfitrion').toUpperCase(),
                    this.xOffset(pdf, this.$t('Anfitrion').toUpperCase()),
                    1.45)
                pdf.setFontSize(16)
                pdf.setFontStyle("normal")
                pdf.text(fullname_host,
                    this.xOffset(pdf, fullname_host),
                    1.70)
                pdf.setTextColor('#000000')
                toDataUrl(company_logo, (logo_guest) => {
                    pdf.addImage(logo_guest, 'WEBP', 0.25, 0.25, 0.9, 0.7)
                    pdf.save('gafete.pdf')
                })
                // pdf.save('gafete.pdf')
            },
            onCapture() {
                this.img = this.$refs.webcam.capture();
            },
            onStarted(stream) {
                this.band = true
                console.log("On Started Event", stream);
            },
            onStopped(stream) {
                console.log("On Stopped Event", stream);
            },
            onStop() {
                this.$refs.webcam.stop();
            },
            onStart() {
                this.$refs.webcam.start();
            },
            onError(error) {
                console.log("On Error Event", error)
            },
            onCameras(cameras) {
                this.devices = cameras
                console.log("On Cameras Event", cameras)
            },
            onCameraChange(deviceId) {
                this.deviceId = deviceId
                this.camera = deviceId
                console.log("On Camera Change Event", deviceId)
            },
            dataURLtoFile(dataurl, filename) {
                var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
                    bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
                while(n--){
                    u8arr[n] = bstr.charCodeAt(n);
                }
                return new File([u8arr], filename, {type:mime});
            },
            estadoFormat(value){
                if (value === 0)
                    return  this.$t('pending_authorization')
                if (value === 1)
                    return  this.$t('adentro')
                if (value === 2)
                    return  this.$t('completado')
                if (value === 3)
                    return  this.$t('no_firmado') + '/' + this.$t('completado')
                if (value === 4)
                    return  this.$t('deny')
                if (value === 5)
                    return  this.$t('waiting_room')
            },
            typeAccessFormat(value) {
              if (value === true)
                return  this.$t('acceso_con_codigo')
              return  this.$t('acceso_sin_codigo')
            },
            get_current_date_menu: function (){
                var today = new Date();
                var dd = today.getDate();
                var mm = today.getMonth()+1;
                var yyyy = today.getFullYear();

                if(dd<10)
                {
                    dd='0'+dd;
                }

                if(mm<10)
                {
                    mm='0'+mm;
                }
                today = yyyy + '-' + mm + '-' + dd;
                return today
            },
            get_current_date_menu2: function (){
                var today = new Date();
                today.setDate(today.getDate() + 7)
                var dd = today.getDate();
                var mm = today.getMonth()+1;
                var yyyy = today.getFullYear();

                if(dd<10)
                {
                    dd='0'+dd;
                }

                if(mm<10)
                {
                    mm='0'+mm;
                }
                today = yyyy + '-' + mm + '-' + dd;
                return today
            },
            get_current_date: function (){
                var today = new Date();
                this.dd = today.getDate();
                this.mm = today.getMonth()+1;
                this.yyyy = today.getFullYear();
                this.dd2 = today.getDate();
                this.mm2 = today.getMonth()+1;
                this.yyyy2 = today.getFullYear();

                if(this.dd<10)
                {
                    this.dd='0'+this.dd;
                }
                if(this.dd2<10)
                {
                    this.dd2='0'+this.dd2;
                }

                if(this.mm<10)
                {
                    this.mm='0'+this.mm;
                }
                if(this.mm2<10)
                {
                    this.mm2='0'+this.mm2;
                }

                today = this.yyyy + '-' + this.mm + '-' + this.dd;
                return today
            },
            formatDate (date) {
                if (!date) return null

                const [year, month, day] = date.split('-')
                return `${day}/${month}/${year}`
            },
            split_date: function(date, date2){
                var arr = date.split('-')
                var arr2 = date2.split('-')

                this.yyyy = arr[0]
                this.mm = arr[1]
                this.dd = arr[2 ]

                this.yyyy2 = arr2[0]
                this.mm2 = arr2[1]
                this.dd2 = arr2[2 ]
            },
            get_access_without_code_by_date: function (yyyy, mm, dd, yyyy2, mm2, dd2) {
                this.loading_data_accesos_without_code = true
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/get_bitacoraByDateRange/' + yyyy + '/'  + mm + '/' + dd + '/'+ yyyy2 + '/'  + mm2 + '/' + dd2 + '/',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept-Language': this.language ,
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };
                axios(config)
                    .then(response => {
                        if(response.status === 204)
                            this.accesos_without_code = []
                        else
                            this.accesos_without_code = response.data
                        this.loading_data_accesos_without_code = false
                    })
                    .catch(error => {
                        this.loading_data_accesos_without_code = false
                        console.log(error)
                    })

            },
            get_access_no_code_express_by_date: function (yyyy, mm, dd, yyyy2, mm2, dd2) {
                this.loading_data_accesos_no_code_express = true
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/get_bitacora_expressByDateRange/' + yyyy + '/'  + mm + '/' + dd + '/'+ yyyy2 + '/'  + mm2 + '/' + dd2 + '/',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept-Language': this.language ,
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };
                axios(config)
                    .then(response => {
                        if(response.status === 204)
                            this.accesos_no_code_express = []
                        else
                            this.accesos_no_code_express = response.data
                        this.loading_data_accesos_no_code_express = false
                    })
                    .catch(error => {
                        this.loading_data_accesos_no_code_express = false
                        console.log(error)
                    })

            },
            get_access_by_date: function (yyyy, mm, dd, yyyy2, mm2, dd2) {
                this.loading_data_accesos = true
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/getAccessByDateRange/' + yyyy + '/'  + mm + '/' + dd + '/' + yyyy2 + '/'  + mm2 + '/' + dd2 + '/',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept-Language': this.language ,
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };
                axios(config)
                    .then(response => {
                        if (response.status === 204)
                            this.accesos = []
                        else
                            this.accesos = response.data
                        this.loading_data_accesos = false
                    })
                    .catch(error => {
                        this.loading_data_accesos = false
                        console.log(error)
                    })

            },
            fill_fields: function(item){
                this.getRecordAccessNoCodeByIdLoading(item.id)
            },
            fill_fields_express: function(item){
                this.data_accesos_no_code_express = item
                console.log(this.data_accesos_no_code_express)
            },
            firmar: function(pk){
                const config = {
                    method: 'patch',
                    url: 'https://empresa-service.intrare.app/firmar_salida/' + pk + '/',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept-Language': this.language ,
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };
                axios(config)
                    .then(response => {
                        this.get_access_without_code_by_date(this.yyyy, this.mm, this.dd, this.yyyy2, this.mm2, this.dd2)
                        console.log('FIRMADO')
                    })
                    .catch(error => {
                        console.log(error)
                    })
            },
            firmar_express: function(pk){
                const config = {
                    method: 'patch',
                    url: 'https://empresa-service.intrare.app/firmar_salida_express/' + pk + '/',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept-Language': this.language ,
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };
                axios(config)
                    .then(response => {
                        this.get_access_no_code_express_by_date(this.yyyy, this.mm, this.dd, this.yyyy2, this.mm2, this.dd2)
                        console.log('FIRMADO')
                    })
                    .catch(error => {
                        console.log(error)
                    })
            },
            exportPdfAccess () {
                var adentro = this.$t('adentro')
                var completado = this.$t('completado')
                var denegado = this.$t('deny')
                var fechaInicial = this.formatDate(this.date)
                var fechaFinal = this.formatDate(this.date2)
                var headerAccessExcel = this.$t('headerAccessExcel')
                var period = this.$t('period')
                var al = this.$t('al')
                var page = this.$t('page')
                var de = this.$t('de')
                var total = 'Total: ' + this.accesos.length.toString()
                var columns = [{
                    guestFName: this.$t('Visitante'),
                    guestLName: this.$t('Apellido'),
                    companyName: this.$t('Empresa'),
                    temperature: this.$t('temperature'),
                    estado: this.$t('estado'),
                    fecha_hora_acceso: this.$t('hora_acceso'),
                    fecha_hora_salida: this.$t('hora_salida'),
                    hostFirstName: this.$t('Anfitrion'),
                    hostLastName: this.$t('Apellido'),
                }]
                var doc = new jsPDF("portrait", "pt", "letter")
                var totalPagesExp = '{total_pages_count_string}'
                doc.autoTable({
                    head: columns,
                    body: this.accesos,
                    didDrawPage: function (data) {
                        // Header
                        doc.setFontSize(20)
                        doc.setTextColor(40)
                        doc.setFontStyle('normal')
                        // if (base64Img) {
                        //     doc.addImage(base64Img, 'JPEG', data.settings.margin.left, 15, 10, 10)
                        // }
                        doc.text(headerAccessExcel, data.settings.margin.left + 20, 38)
                        doc.text(period + fechaInicial + al + fechaFinal, data.settings.margin.left + 20, 60)
                        doc.text(total, data.settings.margin.left + 20, 82)

                        // Footer
                        // var str = page + doc.internal.getNumberOfPages()
                        // Total page number plugin only available in jspdf v1.0+
                        // if (typeof doc.putTotalPages === 'function') {
                        //     str = str + de + totalPagesExp
                        // }
                        // doc.setFontSize(10)

                        // jsPDF 1.4+ uses getWidth, <1.4 uses .width
                        // var pageSize = doc.internal.pageSize
                        // var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
                        // doc.text(str, data.settings.margin.left, pageHeight - 10)
                    },
                    allSectionHooks: true,
                    didParseCell: function (data) {
                        if (data.row.section === 'body') {
                            if (data.column.index === 4) {
                                if (data.cell.text.toString() === '1') {
                                    data.cell.text = adentro
                                } else
                                if (data.cell.text.toString() === '2') {
                                    data.cell.text = denegado
                                } else {
                                    data.cell.text = completado
                                }
                            }
                        }
                    },
                    margin: { top: 90 }
                })
                // Total page number plugin only available in jspdf v1.0+
                if (typeof doc.putTotalPages === 'function') {
                    doc.putTotalPages(totalPagesExp)
                }
                doc.addPage()
                var fechaInicial = this.formatDate(this.date)
                var fechaFinal = this.formatDate(this.date2)
                var headerAccessNoCode = this.$t('accesos_sin_codigo')
                var pendiente = this.$t('pendiente')
                var period = this.$t('period')
                var al = this.$t('al')
                var page = this.$t('page')
                var de = this.$t('de')
                var total = 'Total: ' + this.accesos_without_code.length.toString()
                var columns = [{
                    nombre: this.$t('Visitante'),
                    empresa: this.$t('Empresa'),
                    f_acceso: this.$t('hora_acceso'),
                    f_salida: this.$t('hora_salida'),
                    hostFirstName: this.$t('Anfitrion'),
                }]

                doc.autoTable({
                    head: columns,
                    body: this.accesos_without_code,
                    didDrawPage: function (data) {
                        // Header
                        doc.setFontSize(20)
                        doc.setTextColor(40)
                        doc.setFontStyle('normal')
                        // if (base64Img) {
                        //     doc.addImage(base64Img, 'JPEG', data.settings.margin.left, 15, 10, 10)
                        // }
                        doc.text(headerAccessNoCode, data.settings.margin.left + 20, 38)
                        doc.text(period + fechaInicial + al + fechaFinal, data.settings.margin.left + 20, 60)
                        doc.text(total, data.settings.margin.left + 20, 82)

                        // Footer
                        // var str = page + doc.internal.getNumberOfPages()
                        // // Total page number plugin only available in jspdf v1.0+
                        // if (typeof doc.putTotalPages === 'function') {
                        //     str = str + de + totalPagesExp
                        // }
                        // doc.setFontSize(10)

                        // jsPDF 1.4+ uses getWidth, <1.4 uses .width
                        // var pageSize = doc.internal.pageSize
                        // var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
                        // doc.text(str, data.settings.margin.left, pageHeight - 10)
                    },
                    allSectionHooks: true,
                    didParseCell: function (data) {
                        if (data.column.index === 3) {
                            if(data.cell.text.toString() === ''){
                                data.cell.text = pendiente
                            }
                        }
                    },
                    margin: { top: 90 }
                })
                doc.save('access' + '_' + this.date + '_' + this.date2 + '.pdf')
            },
            exportPdfExpressAccess () {
                var fechaInicial = this.formatDate(this.date)
                var fechaFinal = this.formatDate(this.date2)
                var doc = new jsPDF("portrait", "pt", "letter")
                var totalPagesExp = '{total_pages_count_string}'

                var headerAccessNoCode = this.$t('historial_accesos_sin_codigo')
                var period = this.$t('period')
                var al = this.$t('al')
                var page = this.$t('page')
                var de = this.$t('de')
                var total = 'Total: ' + this.accesos_no_code_express.length.toString()
                var columns = [{
                    nombre: this.$t('Visitante'),
                    areaName: this.$t('Area'),
                    f_acceso: this.$t('hora_acceso'),
                    f_salida: this.$t('hora_salida'),
                    notas: this.$t('Notas'),
                }]

                doc.autoTable({
                    head: columns,
                    body: this.accesos_no_code_express,
                    didDrawPage: function (data) {
                        // Header
                        doc.setFontSize(20)
                        doc.setTextColor(40)
                        doc.setFontStyle('normal')
                        // if (base64Img) {
                        //     doc.addImage(base64Img, 'JPEG', data.settings.margin.left, 15, 10, 10)
                        // }
                        doc.text(headerAccessNoCode, data.settings.margin.left + 20, 38)
                        doc.text(period + fechaInicial + al + fechaFinal, data.settings.margin.left + 20, 60)
                        doc.text(total, data.settings.margin.left + 20, 82)

                        // Footer
                        // var str = page + doc.internal.getNumberOfPages()
                        // // Total page number plugin only available in jspdf v1.0+
                        // if (typeof doc.putTotalPages === 'function') {
                        //     str = str + de + totalPagesExp
                        // }
                        // doc.setFontSize(10)

                        // jsPDF 1.4+ uses getWidth, <1.4 uses .width
                        // var pageSize = doc.internal.pageSize
                        // var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
                        // doc.text(str, data.settings.margin.left, pageHeight - 10)
                    },
                    allSectionHooks: true,
                    // didParseCell: function (data) {
                    //     if (data.column.index === 3) {
                    //         if(data.cell.text.toString() === ''){
                    //             data.cell.text = pendiente
                    //         }
                    //     }
                    // },
                    margin: { top: 90 }
                })
                // Total page number plugin only available in jspdf v1.0+
                if (typeof doc.putTotalPages === 'function') {
                    doc.putTotalPages(totalPagesExp)
                }
                doc.save('accessNocode' + '_' + this.date + '_' + this.date2 + '.pdf')
            },
            submit: function(){
                this.split_date(this.date, this.date2)
                this.get_access_union_by_date(this.yyyy, this.mm, this.dd, this.yyyy2, this.mm2, this.dd2)
                this.get_access_no_code_express_by_date(this.yyyy, this.mm, this.dd, this.yyyy2, this.mm2, this.dd2)
            },
            get_access_union_by_date: function (yyyy, mm, dd, yyyy2, mm2, dd2) {
                this.loading_data_access2 = true
                const reqUnion = axios({
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/getAccessByDateRangeUnion/' + yyyy + '/'  + mm + '/' + dd + '/' + yyyy2 + '/'  + mm2 + '/' + dd2 + '/',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept-Language': this.language ,
                        'authorization': 'Token ' + store.getters.getToken
                    }
                });

                const reqShipments = axios({
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/shipments/guard/access-logs/',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    },
                    params: {
                        start_date: yyyy + '-' + mm + '-' + dd + ' 00:00',
                        end_date: yyyy2 + '-' + mm2 + '-' + dd2 + ' 23:59',
                        empresa_id: this.id_empresa || this.getProfile.id_company
                    }
                }).catch(e => ({ data: [] }));

                const reqParking = axios({
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/Parking/invitations/history/',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    },
                    params: {
                        start_date: yyyy + '-' + mm + '-' + dd,
                        end_date: yyyy2 + '-' + mm2 + '-' + dd2,
                        empresa_id: this.id_empresa || this.getProfile.id_company
                    }
                }).catch(e => ({ data: [] }));

                Promise.all([reqUnion, reqShipments, reqParking])
                    .then(responses => {
                        let normalAccess = responses[0].data || [];
                        let shipmentsAccess = responses[1].data || [];
                        let parkingAccess = responses[2].data || [];
                        if (shipmentsAccess.results) shipmentsAccess = shipmentsAccess.results;

                        normalAccess = normalAccess.map(item => {
                            let tipo_texto = item.type_invitation_text;
                            if (tipo_texto === 'Bitacora Manual' || tipo_texto === 'Manual Log') {
                                tipo_texto = this.$t ? this.$t('acceso_sin_codigo') : 'Acceso sin Código';
                            }
                            if (!tipo_texto) {
                                tipo_texto = item.typeInv === 2 ? (this.$t ? this.$t('recurrente') : 'Recurrente') : (item.typeInv === 1 ? (this.$t ? this.$t('empresarial') : 'Empresarial') : (this.$t ? this.$t('ininvitación_normal') : 'Normal'));
                            }
                            return {
                                ...item,
                                tipo_registro: tipo_texto,
                                type_invitation_text: tipo_texto,
                                is_recurring: item.typeInv === 2 || item.type_invitation === 2
                            };
                        });

                        const formatDateTime = (dateStr) => {
                            if (!dateStr) return null;
                            const d = new Date(dateStr);
                            if (isNaN(d.getTime())) return dateStr;
                            
                            const day = String(d.getDate()).padStart(2, '0');
                            const month = String(d.getMonth() + 1).padStart(2, '0');
                            const year = d.getFullYear();
                            
                            const hours = String(d.getHours()).padStart(2, '0');
                            const minutes = String(d.getMinutes()).padStart(2, '0');
                            
                            return `${year}-${month}-${day} ${hours}:${minutes}`;
                        };

                        let mappedShipments = shipmentsAccess.map(item => ({
                            id: item.id,
                            is_shipment: true,
                            tipo_registro: 'Embarque',
                            access_qr_code: true,
                            contractor: false,
                            guest_full_name: item.driver_name || item.guest_name || 'Conductor',
                            company_name: item.carrier_company || item.carrier || 'Embarques',
                            status: item.exit_time ? 2 : 1, // 1: inside, 2: completed
                            authorized: true,
                            datetime_arrival: formatDateTime(item.access_time),
                            datetime_checkin: formatDateTime(item.access_time),
                            datetime_checkout: formatDateTime(item.exit_time),
                            host_full_name: item.host_name || 'Embarques',
                            download: null,
                            placas: item.vehicle_plate || null,
                            qr_code: item.qr_code,
                            exit_pass: true // So it doesn't show "No firmado"
                        }));

                        let mappedParking = parkingAccess.map(item => ({
                            id: item.id,
                            is_parking: true,
                            tipo_registro: this.$t && this.$t('parking') ? this.$t('parking') : 'Estacionamiento',
                            access_qr_code: true,
                            contractor: false,
                            guest_full_name: item.guest_name || 'Invitado',
                            company_name: item.company_name || '-',
                            status: item.exit_time ? 2 : 1, // 1: inside (sin salida), 2: completed (con salida)
                            authorized: true,
                            datetime_arrival: "-",
                            datetime_checkin: formatDateTime(item.access_time),
                            datetime_checkout: formatDateTime(item.exit_time),
                            host_full_name: item.host_name || 'Estacionamiento',
                            download: null,
                            placas: null,
                            qr_code: item.qr_code,
                            exit_pass: true // So it doesn't show "No firmado"
                        }));

                        let allAccess = normalAccess.concat(mappedShipments).concat(mappedParking);
                        allAccess.sort((a,b) => new Date(b.datetime_checkin || 0) - new Date(a.datetime_checkin || 0));
                        this.access = allAccess;
                        this.loading_data_access2 = false;
                    })
                    .catch(error => {
                        this.loading_data_access2 = false
                        console.log(error)
                    });
            },
            addAccessCarrierData () {
              this.loading = true
              let URL_ACCESS = 'https://empresa-service.intrare.app/empresas/access/update/transport_data/' + this.idAccess + '/'
              let URL_ACCESS_NO_CODE = 'https://empresa-service.intrare.app/bitacora/update/transport_data/' + this.idAccess + '/'
              let URL_ACCESS_CONTRACTOR = 'https://empresa-service.intrare.app/access_contractor/update/transport_data/' + this.idAccess + '/'
              let URL_FINAL = ''
              if(this.accessQRCode === false) {
                URL_FINAL = URL_ACCESS_NO_CODE
              } else {
                if (this.accessContractor === true) {
                    URL_FINAL = URL_ACCESS_CONTRACTOR
                } else {
                    URL_FINAL = URL_ACCESS
                }
              }
              // console.log('Tipo de Servicio = ', this.typeService)
              if (this.typeService !== null && this.case_plates === null && this.container_platform_plates === null && this.transport_line === null && this.supplier_customer_name === null)
              {
                  this.bandConfirm = true
                  this.loading = false
              } else
                if (this.typeService === null) {
                  this.loading = false
                } else {
                  const config = {
                    method: 'patch',
                    url: URL_FINAL,
                    headers: {
                      'Content-Type': 'application/json',
                      'Accept-Language': this.language,
                      'authorization': 'Token ' + store.getters.getToken
                    },
                    data: {
                      download: this.typeService,
                      case_plates: this.case_plates,
                      container_platform_plates: this.container_platform_plates,
                      transport_line: this.transport_line,
                      supplier_customer_name: this.supplier_customer_name
                    }
                  };
                  axios(config)
                      .then(response => {
                        this.loading = false
                        this.dialogTransport = false
                        this.$store.commit('snackbar_activate_true')
                        this.$store.commit('snackbar_change_color', 'success')
                        this.$store.commit('snackbar_change_message', this.$t('data_added_successfully'))
                        this.get_access_union_by_date(this.yyyy, this.mm, this.dd, this.yyyy2, this.mm2, this.dd2)
                        setTimeout(this.clear, 3000)
                      })
                      .catch(error => {
                        this.loading = false
                        console.log(error)
                      })
                }
            },
            altaPlacas () {
                this.loading = true
                this.errores = []
                var bodyFormData = new FormData()
                var fileImage = null
                const newID = this.$uuid.v4()

                if (this.img !== '' && this.img.length > 6) {
                    fileImage = this.dataURLtoFile(this.img, 'picture' + newID + '.png')
                }
                bodyFormData.append('placas', fileImage)
                const config = {
                    method: 'patch',
                    url: 'https://empresa-service.intrare.app/empresas/access/update/placas/' + this.idAccess + '/',
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        'authorization': 'Token ' + store.getters.getToken,
                        'Accept-Language': this.language,
                    },
                    data: bodyFormData
                };
                axios(config)
                    .then(ok => {
                        this.loading = false
                        this.$store.commit('snackbar_activate_true')
                        this.$store.commit('snackbar_change_color', 'success')
                        this.$store.commit('snackbar_change_message', this.$t('placas_alta'))
                        this.get_access_union_by_date(this.yyyy, this.mm, this.dd, this.yyyy2, this.mm2, this.dd2)
                        setTimeout(this.clear, 3000)
                    })
                    .catch(error => {
                        this.loading = false
                        console.log(error)
                    })
                    .finally(() => (this.loading = false, this.dialogPlacas =false))

            },
            clear () {
                this.alerta = false
                this.errores = []
                this.$store.commit('snackbar_activate_false')
                this.$store.commit('snackbar_change_color', 'success')
                this.img = ''
            },
        }
    }
</script>


<style scoped>
    .error {
        font-weight: bold;
        color: red;
    }

    #datas {
        font-family: "Trebuchet MS", Arial, Helvetica, sans-serif;
        border-collapse: collapse;
        width: 100%;
    }

    #datas td, #datas th {
        padding: 8px;
    }

    #datas tr:nth-child(even){background-color: #f2f2f2;}

    #datas tr:hover {background-color: #ddd;}

    #datas th {
        padding-top: 12px;
        padding-bottom: 12px;
        text-align: left;
        background-color: #002b48;
        color: white;
    }
</style>
